import React, { useState, useContext } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { LanguageContext } from "../../context/LanguageContext";
import "./Navbar.css"
import "./LanguageSwitcher.css"

const LanguageSwitcher = () => {
  const { currentLang, setCurrentLang, displayName } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);

  return (
    <div className="lang-wrapper">
      <div className="lang-select-container" dir="ltr">
        <select
          className="lang-switch"
          value={currentLang}
          onChange={(e) => setCurrentLang(e.target.value)}
          onClick={() => setOpen(!open)}     // arrow toggle
          onBlur={() => setOpen(false)}      // close when unfocused
        >
          <option value="en">{displayName.en}</option>
          <option value="ar">{displayName.ar}</option>
          <option value="ku">{displayName.ku}</option>
        </select>

        <div className="lang-arrow">
          {open ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
